import { universityRestriction } from '../../utility/universityRestrictions';

interface CustomNodesParams {
  universityPlan: {
    code?: string;
  };
  defaultNodes: { type?: string }[];
  sectionKey: string | undefined;
}

const getCustomNodes = ({
  universityPlan,
  defaultNodes,
  sectionKey,
}: CustomNodesParams) => {
  const excludeFields =
    (sectionKey &&
      universityPlan?.code &&
      universityRestriction[universityPlan?.code]?.editor?.resume?.[sectionKey]
        ?.excludeFields) ||
    false;

  if (excludeFields) {
    return defaultNodes.filter((node) => !excludeFields.includes(node?.type));
  }
  return defaultNodes;
};
export default getCustomNodes;
